module.exports = __webpack_public_path__ + "static/media/git.9a073b4c.png";